import PropTypes from "prop-types";
import { useState } from "react";
import { Modal, Box } from "@mui/material";
import { ResourceLinks } from "../../constants/";
const modalStyle = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "100%",
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 1,
};
const Image = ({ src, value = "ACSF Image", style = {}, allowFullscreen = false }) => {
	const [open, setOpen] = useState(false);
    const handleFullScreen = () => {
        if (allowFullscreen)
            setOpen(true);
    }
	return (
		<>
			<img
				src={`${ResourceLinks.images}${src}`}
				alt={value}
				style={{ maxWidth: "100%", ...style }}
				loading="eager"
				onClick={handleFullScreen}
			/>
			<Modal
				open={open}
				onClose={() => setOpen(false)}
				aria-labelledby="preview-image"
				aria-describedby="preview-image-description"
			>
				<Box sx={modalStyle}>
					<img
						src={`${ResourceLinks.images}${src}`}
						alt={value}
						style={{ maxHeight: "100%", maxWidth: "100%" }}
					/>
				</Box>
			</Modal>
		</>
	);
};

Image.propTypes = {
	src: PropTypes.string,
	value: PropTypes.string,
	style: PropTypes.any,
};
export default Image;
